const agencyInitialState = {
    agency_credit: 0,
    noti_admins: {},
    unread_noti_admin: 0,
}
const agencyReducer = (state = agencyInitialState, action) => {
    switch (action.type) {
        case 'updateAgencyCredit':
            return { ...state, agency_credit: action.item.agency_credit };
        case 'updateNotiAdmin':
            return { ...state, noti_admins: action.item.noti_admins, unread_noti_admin: action.item.unread_noti_admin }
        default:
            return state
    }
}

export default agencyReducer;